import { GridActionsCellItem } from '@mui/x-data-grid';
import { Paper, IconButton, Grid, Tooltip } from '@mui/material';
import { Add as AddIcon, Edit as EditIcon } from '@mui/icons-material';
import { GridRowParams } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link as RouterLink, useNavigate } from 'react-router';
import { useSnackbar } from 'notistack';
import useCheckPermission from '../../hooks/useCheckPermission';
import roleCatalogService from './roleCatalogService';
import DataList from '../../components/DataList';

const RoleCatalogPage = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState<any[]>([]);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch<any>();
  const { canPlatform } = useCheckPermission();

  useEffect(() => {
    dispatch({ type: 'SHOW_QUERY' });
    roleCatalogService
      .listTemplates()
      .then((response) => {
        if (!response.hasError) setRows(response.records);
        else
          enqueueSnackbar((response.errorMessages ?? []).join(','), {
            variant: 'error',
          });
      })
      .finally(() => dispatch({ type: 'HIDE' }));
  }, []);

  const getActions = (params: GridRowParams) => [
    <GridActionsCellItem
      key="edit"
      color="primary"
      icon={
        <Tooltip title="Edit">
          <EditIcon />
        </Tooltip>
      }
      label="Edit"
      onClick={() => navigate(`/role-catalog/edit/${params.row.id}`)}
    />,
  ];

  return (
    <Paper>
      <Grid container sx={{ p: 3 }}>
        <Grid size={12}>
          <h2>Bérlő szerepkörök</h2>
        </Grid>
        {canPlatform(['ManageRoleCatalog']) && (
          <Grid container size={12} sx={{ p: 2, justifyContent: 'end' }}>
            <Grid>
              <Tooltip title="Új bérlő szerepkör">
                <IconButton
                  component={RouterLink}
                  to={`/role-catalog/create`}
                  color="primary"
                >
                  <AddIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        )}
        <Grid size={12}>
          <DataList
            rows={rows}
            columns={[
              { field: 'name', headerName: 'Name', flex: 100 },
              { field: 'description', headerName: 'Description', flex: 140 },
              { field: 'isPublished', headerName: 'Published', flex: 60 },
              { field: 'isSystem', headerName: 'System', flex: 60 },
              { field: 'actions', type: 'actions', flex: 30, getActions },
            ]}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default RoleCatalogPage;
